function view (path) {
  return () => import(/* webpackChunkName: 'mkm-v2' */ '@/views/mkm/' + path + '.vue').then(m => m.default || m) // eslint-disable-line prefer-template
}

const RMKMOfficer = [
  {
    path: '/mkm/dashboard',
    component: view('Dashboard'),
    name: 'mkm.dashboard'
  },
  {
    path: '/mkm',
    component: view('Memos'),
    children: [
      {
        path: 'memos',
        component: view('memos/Base'),
        name: 'mkm.memos',
        meta: {
          breadcrumb: [
            {
              text: 'MKM',
              to: {
                name: 'mkm.dashboard'
              }
            },
            {
              text: 'Memos',
              active: true
            }
          ]
        }
      },
      {
        path: 'signed-memos',
        component: view('memos/signed-memos/Base'),
        name: 'mkm.memos.signed-memos',
        meta: {
          breadcrumb: [
            {
              text: 'MKM',
              to: {
                name: 'mkm.dashboard'
              }
            },
            {
              text: 'Memos',
              active: true
            }
          ]
        }
      }
    ]
  }
]

const RMKMOfficerReports = [
]

export default RMKMOfficer.concat(
  RMKMOfficerReports
)
